import React from "react";
import {Button, Collapse, Grid, MenuItem, Select, TextField} from "@mui/material";
import VariabiliGlobali from "../../Back/VariabiliGlobali";
import axios from "axios";
import {ReactSession} from "react-client-session";

class FiltriArticoli extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            descrizione: props.descrizione,
            marca: props.marca,
            reparto: props.reparto,
            promo: props.promo,
            idpromo: props.idpromo,
            repartiArr: [],
            open: false,
            testoFiltriArticoli: "Mostra filtri articoli"
        }
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
        this.chiediReparti();
    }

    chiediReparti() {
        const params = new URLSearchParams();
        params.append('idmagazzino', this.idmagazzino);
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiReparti';
        axios.post(url, params, config)
            .then((response) => {
                this.setState({repartiArr: response.data})
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(JSON.stringify(error))
            })
    }

    handleChange(event, provenienza) {
        if (provenienza === 'descrizione') {
            this.props.handleChangeArticolo(event.target.value, this.state.marca, this.state.reparto, this.state.promo, this.state.idpromo);
            this.setState({descrizione: event.target.value});
        }
        if (provenienza === 'marca') {
            this.props.handleChangeArticolo(this.state.descrizione, event.target.value, this.state.reparto, this.state.promo, this.state.idpromo);
            this.setState({marca: event.target.value});
        }
        if (provenienza === 'idpromo') {
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, event.target.value);
            this.setState({idpromo: event.target.value});
        }
        if (provenienza === 'reparto') {
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, event.target.value, this.state.promo, this.state.idpromo);
            this.setState({reparto: event.target.value});
        }
        if (provenienza === 'promo') {
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, event.target.value, this.state.idpromo);
            this.setState({promo: event.target.value});
        }
        if (provenienza === 'btnOpen') {
            this.setState({open: !this.state.open})
            if (this.state.open.toString() !== "true") {
                this.setState({testoFiltriArticoli: "Nascondi filtri articoli"})
            } else {
                this.setState({testoFiltriArticoli: "Mostra filtri articoli"})
            }
        }
    }

    getNomiReparti = function () {
        return this.state.repartiArr.map((el, i) =>
            <MenuItem value={el.idreparto}>{el.nome}</MenuItem>
        )
    }

    render() {

        return (
            <div>
                <Button variant="contained" onClick={(e) => this.handleChange(e, "btnOpen")}>
                    {this.state.testoFiltriArticoli}
                </Button>
                <Collapse in={this.state.open}>
                    <div className="elemento">
                        <Grid container direction="row" spacing={3}>
                            <Grid item>
                                <TextField autoFocus
                                           label="Descrizione"
                                           value={this.state.descrizione}
                                           defaultValue={this.state.descrizione}
                                           onChange={(e) => this.handleChange(e, "descrizione")}/>

                            </Grid>
                            <Grid item>
                                <TextField autoFocus
                                           label="Marca"
                                           value={this.state.marca}
                                           defaultValue={this.state.marca}
                                           onChange={(e) => this.handleChange(e, "marca")}/>

                            </Grid>
                            <Grid item>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="filtroRep"
                                    value={this.state.reparto}
                                    label=''
                                    onChange={(e) => this.handleChange(e, "reparto")}>
                                    <MenuItem value={'0'}>Scelta reparto</MenuItem>
                                    {this.getNomiReparti()}
                                </Select>
                            </Grid>
                            <Grid item>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="filtroRep"
                                    value={this.state.promo}
                                    label=''
                                    onChange={(e) => this.handleChange(e, "promo")}>
                                    <MenuItem value={'0'}>Scelta promo</MenuItem>
                                    <MenuItem value={'1'}>Solo articoli in promo</MenuItem>
                                    <MenuItem value={'2'}>Escludi articoli in promo</MenuItem>
                                    <MenuItem value={'3'}>Escludi articoli promozione specifica:</MenuItem>
                                    <MenuItem value={'4'}>Solo promozione specifica:</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item>
                                <TextField autoFocus
                                           label="ID Promo: "
                                           value={this.state.idpromo}
                                           defaultValue={this.state.idpromo}
                                           onChange={(e) => this.handleChange(e, "idpromo")}/>

                            </Grid>
                        </Grid>
                    </div>
                </Collapse>
            </div>

        )

    }
}

export default FiltriArticoli

export function dammiArticoli(descrizione, marca, reparto, promo, idpromo) {
    return new Promise(async function (resolve, reject) {
        const params = new URLSearchParams();
        let idmagazzino = ReactSession.get("idmagazzino");
        params.append('idmagazzino', idmagazzino);
        params.append('descrizione', descrizione);
        params.append('marca', marca);
        params.append('reparto', reparto);
        params.append('promo', promo);
        params.append('idpromo', idpromo);

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }

        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiIDArticoli';
        await axios.post(url, params, config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                resolve("(0)");
            })

    })
}


